import React from 'react';
import { GuideDTO } from 'dto/guide';
import BookList from './BookList';

interface Props {
  groupName: string;
  guideList: GuideDTO[];
  className: string;
}

const GuideListGroup = (props: Props) => (
  <>
    <div className={props.className}>{props.groupName}</div>
    <BookList guideList={props.guideList} />
  </>
);

export default GuideListGroup;
